import { FoodsTags } from "@foodpilot/foods";
import { ACTION_STATUS } from "./actionStatus";
import { Box } from "@mui/material";

type StatusTagProps = {
    label?: string;
};
export const StatusTag = (props: StatusTagProps) => {
    const { label } = props;

    if (label === undefined) {
        return null;
    }

    const allStatus = ACTION_STATUS;
    const selectedStatus = allStatus.find((status) => status.backendLabel === label);

    if (selectedStatus === undefined) {
        return (
            <Box>
                <FoodsTags disabled label="deleted-tag" variant="tags-black" />
            </Box>
        );
    }

    if (selectedStatus.display === false) {
        return null;
    }

    return (
        <Box>
            <FoodsTags disabled label={selectedStatus.label} variant={selectedStatus.color} />
        </Box>
    );
};
